;(function () {
  'use strict'

  angular
    .module('contrast.services.applications.libraries.stats', [])
    .factory('LibrariesStatsVisibilityService', [
      LibrariesStatsVisibilityService
    ])

  function LibrariesStatsVisibilityService() {
    var service = {
      model: {
        visible: false
      },
      init: init
    }

    return service

    function init() {
      service.model.visible = false
    }
  }
})()
